import { ClientPortfolioPaymentFrequencyEnum } from "web_myplann/Infrastructure/Api/Api";
import type { LifeInsuranceFormInput } from "web_myplann/Portfolio/Forms/LifeInsuranceForm/lifeInsuranceFormSchema";

export const LIFE_INSURANCE_FORM_DEFAULT_VALUES: LifeInsuranceFormInput = {
	name: "",
	contractNumber: "",
	producer: "",
	product: "",
	insurance: null,
	paymentFrequency: ClientPortfolioPaymentFrequencyEnum.Monthly,
	employerContribution: null,
	insuredPersons: [],
	tools: [],
	value: null,
	invested: null,
	valueDate: null,
	signedAt: null,
	startAt: null,
	endAt: null,
};

export const getLifeInsuranceCreateFormDefaultValues =
	(): LifeInsuranceFormInput => ({
		...LIFE_INSURANCE_FORM_DEFAULT_VALUES,
		valueDate: new Date(),
	});
